import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BP_ASSETS_PARTNERS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_bundle_load = (data) => {
    return (dispatch, getState) => {


        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/bp/client/bundle-load-source`, config)
                .then(response => {
                    dispatch({
                        type: BP_ASSETS_PARTNERS_GET,
                        payload: {
                            bundleClientSource: response.data,
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    });
                })
                .catch(error => {
                    dispatch({
                        type: BP_ASSETS_PARTNERS_GET,
                        payload: {
                            bundleClientSource: {
                                errors: {},
                            },
                            task: {
                                result: false
                            }
                        }
                    })
                });

        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_bundle_load;
